module.exports = __webpack_public_path__ + "media/images/front/icons/clinicbook-b557c1e5d86b8038069c64511e44de93.png";